<template>
  <page-wrap>
    <grid :config="gridConfig"/>
    <editor
      :config="{id: gridConfig.id, api: 'Shippers/Get/'}"
      :disabled="isDisabledForm"
    />
  </page-wrap>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'ShippersIndex',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'Shippers' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  computed: {
    isDisabledForm () {
      return !this.permission(this.$store.getters.get('permissions'), 'isAllowToEditCompanies')
    }
  }
}
</script>
